export const reminderOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  // align: 'center',
  index: false,
  selection: true,
  menu: true,
  page: true,
  addBtn: false,
  editBtn: true,
  delBtn: false,
  columnBtn: false,
  viewBtn: true,
  menuWidth: "200",
  labelWidth: "150",
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    {
      label: "值",
      prop: "phone",
      type: "input",
      search: true,
      span: 12,
      placeholder: "请输入值",
    },
    {
      label: "编码",
      prop: "flag",
      type: "input",
      span: 12,
    }
  ],
};
